var _path, _path2, _rect, _path3, _path4, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTubes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00065 4.16667V15C5.00065 15.4602 5.37375 15.8333 5.83398 15.8333C6.29422 15.8333 6.66732 15.4602 6.66732 15V4.16667H5.00065ZM4.16732 2.5C3.70708 2.5 3.33398 2.8731 3.33398 3.33333V15C3.33398 16.3807 4.45327 17.5 5.83398 17.5C7.2147 17.5 8.33398 16.3807 8.33398 15V3.33333C8.33398 2.8731 7.96089 2.5 7.50065 2.5H4.16732Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3327 4.16667V15C13.3327 15.4602 13.7058 15.8333 14.166 15.8333C14.6263 15.8333 14.9993 15.4602 14.9993 15V4.16667H13.3327ZM12.4993 2.5C12.0391 2.5 11.666 2.8731 11.666 3.33333V15C11.666 16.3807 12.7853 17.5 14.166 17.5C15.5467 17.5 16.666 16.3807 16.666 15V3.33333C16.666 2.8731 16.2929 2.5 15.8327 2.5H12.4993Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 5.8335,
    width: 3.33333,
    height: 1.66667,
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3.33333C2.5 2.8731 2.8731 2.5 3.33333 2.5H8.33333C8.79357 2.5 9.16667 2.8731 9.16667 3.33333C9.16667 3.79357 8.79357 4.16667 8.33333 4.16667H3.33333C2.8731 4.16667 2.5 3.79357 2.5 3.33333Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 3.33333C10.8333 2.8731 11.2064 2.5 11.6667 2.5H16.6667C17.1269 2.5 17.5 2.8731 17.5 3.33333C17.5 3.79357 17.1269 4.16667 16.6667 4.16667H11.6667C11.2064 4.16667 10.8333 3.79357 10.8333 3.33333Z",
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.16602,
    y: 10,
    width: 3.33333,
    height: 1.66667,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTubes);
export default __webpack_public_path__ + "static/media/tubes.4c36894281e4bc336944f768e68bb61f.svg";
export { ForwardRef as ReactComponent };